import React from 'react';
import PropTypes from 'prop-types';
import {pushFormTrackingEvent} from './push-form-tracking-event';

class MicroformFieldComponent extends React.Component {
    microformField = null

    componentWillReceiveProps(nextProps) {
        if (this.microformField === null && nextProps.microformField !== null) {
            this.microformField = nextProps.microformField;
            this.microformField.on('change', this.onChange);
            this.microformField.on('blur', this.onBlur);
        }
    }

    componentWillUnmount() {
        if (this.microformField) {
            this.microformField.off('change', this.onChange);
            this.microformField.off('blur', this.onBlur);
        }
    }

    onBlur = () => {
        const {form: {setFieldTouched}, field: {name}} = this.props;
        pushFormTrackingEvent(name);
        setFieldTouched(name, true);
    }

    onChange = data => {
        const {form: {setFieldValue}, field: {name}} = this.props;
        setFieldValue(name, data);
    }


    render() {
        const {id} = this.props;
        return (
            <div id={id} className="flex-microform" />
        );
    }
}

MicroformFieldComponent.getInitialFieldValues = () => ({
    empty: true,
    valid: false
});

MicroformFieldComponent.defaultProps = {
    microformField: null
};

MicroformFieldComponent.propTypes = {
    id: PropTypes.string.isRequired,
    microformField: PropTypes.shape(),
    field: PropTypes.shape({
        name: PropTypes.string.isRequired
    }).isRequired,
    form: PropTypes.shape({
        setFieldValue: PropTypes.func.isRequired,
        setFieldTouched: PropTypes.func.isRequired
    }).isRequired
};

export default MicroformFieldComponent;
